// extracted by mini-css-extract-plugin
module.exports = {"flexRight":"flexRight___4YwtY","Steps":"Steps___2JEV-","rptCard":"rptCard___2Jgfn","detailHeader":"detailHeader___1RZZt","rptSuccess":"rptSuccess___1drLB"};